import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import { utils, defaultStyles, dimensionsHelper, addPresetStyles, } from 'pro-gallery-lib';
import ProGallery from './proGallery/proGallery';
import basePropTypes from './proGallery/propTypes';
import isEligibleForLeanGallery from './leanGallery/isEligible';
import LeanGallery, { formatLeanGalleryStyles, } from './leanGallery/leanGallery';
var BaseGallery = /** @class */ (function (_super) {
    __extends(BaseGallery, _super);
    function BaseGallery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseGallery.prototype.render = function () {
        var domId = this.props.domId || 'default-dom-id';
        var _a = this.props, styles = _a.styles, options = _a.options, styleParams = _a.styleParams, eventsListener = _a.eventsListener, otherProps = __rest(_a, ["styles", "options", "styleParams", "eventsListener"]);
        var _eventsListener = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return typeof eventsListener === 'function' && eventsListener.apply(void 0, args);
        };
        var _styles = __assign(__assign(__assign(__assign({}, defaultStyles), options), styles), styleParams);
        var galleryProps = __assign(__assign({}, otherProps), { styles: _styles, eventsListener: _eventsListener, domId: domId });
        var shouldRenderLean = isEligibleForLeanGallery(galleryProps);
        var key = [domId, shouldRenderLean].join('_');
        if (this.props.useBlueprints) {
            //
        }
        else {
            dimensionsHelper.updateParams({
                domId: galleryProps.domId,
                container: galleryProps.container,
                styles: galleryProps.styles,
            });
            var _b = galleryProps.styles, galleryType = _b.galleryType, galleryLayout = _b.galleryLayout;
            if (galleryType === undefined || galleryLayout !== undefined) {
                galleryProps = __assign(__assign({}, galleryProps), { styles: addPresetStyles(galleryProps.styles) });
            }
        }
        var GalleryComponent = ProGallery;
        if (shouldRenderLean) {
            galleryProps.styles = formatLeanGalleryStyles(galleryProps.styles);
            GalleryComponent = LeanGallery;
        }
        utils.logPlaygroundLink(galleryProps.styles);
        return React.createElement(GalleryComponent, __assign({ key: key }, galleryProps));
    };
    BaseGallery.propTypes = basePropTypes;
    return BaseGallery;
}(React.Component));
export default BaseGallery;
//# sourceMappingURL=index.js.map